import { LearningItemStatus } from '../../models/BaseModels'
import * as api from '../api'
import useApiMutation from './useApiMutation'
import useInvalidate from '../useInvalidate'

export type UpdateLearningPathArgs = {
  uuid: string
  status?: LearningItemStatus
  title?: string
  description?: string
  categories?: string[]
  createCertificate?: boolean
  certificateValidUntil?: Date | null | undefined
  image?: string
  courses?: string[]
}

export default function useUpdateLearningPath() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async (data: UpdateLearningPathArgs) => {
      // Send update only for fields that are modified
      const result = await api.patch(`learning-path/${data.uuid}`, {
        ...(data.status ? { status: data.status } : {}),
        ...(data.title ? { title: data.title } : {}),
        ...(data.description ? { description: data.description } : {}),
        ...(data.categories ? { categories: data.categories } : {}),
        ...(data.createCertificate !== undefined ? { createCertificate: data.createCertificate } : {}),
        ...(data.certificateValidUntil !== undefined ? { certificateValidUntil: data.certificateValidUntil } : {}),
        ...(data.image ? { image: data.image } : {}),
        ...(data.courses ? { courses: data.courses } : {}),
      })

      invalidate.courses()

      return result
    },
  })
}
